import { ChevronRight } from 'lucide-react';

interface Props {
  label: string;
  value: string;
  disabled?: boolean;
  selected?: boolean;
  onClick: () => void;
}

const POSSelectorButton = ({ label, value, disabled, onClick }: Props) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className="
        w-full

        rounded-xl
        border

        border-stroke
        bg-white

        p-3

        text-left

        transition-all
        duration-200

        hover:border-primary

        disabled:cursor-not-allowed
        disabled:opacity-60

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <div
        className="
          flex
          items-center
          justify-between
          gap-3
        "
      >
        <div className="min-w-0 flex-1">
          <p
            className="
              text-[11px]
              font-medium

              text-body
              dark:text-bodydark2
            "
          >
            {label}
          </p>

          <p
            className="
              truncate

              text-sm
              font-semibold

              text-black
              dark:text-white
            "
          >
            {value}
          </p>
        </div>

        <ChevronRight
          className="
            h-4
            w-4

            shrink-0

            text-body
            dark:text-bodydark2
          "
        />
      </div>
    </button>
  );
};

export default POSSelectorButton;
